import './App.css';
import Allroutes from './routes';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
function App() {
  return (
 <Allroutes />
  );
}



export default App;

